<template>
  <div class="tags-views">
    <div class="tag-item" v-for="(item, i) in tabList" :key="i" :class="{'active' : item.name === $route.name}" @click="changeRoute(item)">
      <span>{{ item.meta.title || 'no-name' }}</span>
      <i class="icon el-icon-error" v-if="i > 0" @click.stop="closeTab(i)"></i>
    </div>
    <!-- 右键菜单 -->
    <div class="context-menu-contain">
      <div class="menu-item" @click="refresh(index)" v-if="tabList[index] && ($route.name === tabList[index].name)">刷新</div>
      <div class="menu-item" @click="closeTab(index)" v-if="index !== 0">关闭</div>
      <div class="menu-item" @click="closeOther(index)">关闭其他</div>
      <div class="menu-item" @click="closeAll" v-if="index !== 0">关闭所有</div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  inject: ['reload'],
  mounted () {
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function () {
        this.$store.commit('addTabToList', this.$route)
        this.handleContextMenu()
      }
    }
  },
  computed: {
    tabList () {
      return this.$store.state.Tabs.tabList
    }
  },
  data () {
    return {
      index: 0
    }
  },
  methods: {
    // 绑定右键事件
    handleContextMenu () {
      this.$nextTick(() => {
        document.onclick = () => {
          $('.context-menu-contain').hide()
        }
        $('.tag-item').contextmenu(e => {
          $('.context-menu-contain').hide()
          let index = $(e.currentTarget).index()
          this.index = index
          $('.context-menu-contain').css({
            display: 'block',
            top: e.pageY + 10,
            left: e.pageX + 10
          })
          return false
        })
      })
    },
    // 切换tab
    changeRoute (item) {
      this.$router.push({
        path: item.fullPath
      })
    },
    // 关闭tab
    closeTab (index) {
      let item = this.tabList[index]
      let isActive = item.name === this.$route.name
      this.$store.commit('delTab', item)
      if (isActive) {
        // 如果关闭的是当前路由
        this.$router.push({
          path: this.tabList[index - 1].fullPath
        })
      }
    },
    // 关闭其他
    closeOther (index) {
      this.$store.commit('delOtherTabs', index)
      this.$router.push({
        path: this.tabList.at(-1).fullPath
      })
    },
    // 关闭所有
    closeAll () {
      this.$store.commit('clearTabs')
      console.log('tabList', this.tabList)
      this.$router.push({
        path: this.tabList[0].fullPath
      })
    },
    // 刷新当前页面
    refresh () {
      this.reload()
    }
  }
}
</script>

<style lang="less" scoped>
.tags-views{
  display: flex;
  align-items: center;
  height: 52px;
  background-color: #fff;
  padding: 0 20px;
  overflow-x: auto;
  .tag-item{
    display: flex;
    align-items: center;
    flex-shrink: 0;
    font-size: 14px;
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 0 8px;
    margin-right: 6px;
    height: 30px;
    cursor: pointer;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .1);
    .icon{
      margin-left: 6px;
      color: #ccc;
      &:hover{
        color: #333;
      }
    }
    &.active{
      background-color: #3388FF;
      color: #fff;
      border-color: transparent;
      .icon:hover{
        color: #fff;
      }
      &::before{
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        background-color: #fff;
        border-radius: 50%;
        margin-right: 6px;
      }
    }
  }
  .context-menu-contain{
    display: none;
    top: 0;
    left: 0;
    width: 80px;
    background-color: #fff;
    border: 1px solid #eee;
    position: absolute;
    z-index: 99;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .1);
    border-radius: 8px;
    overflow: hidden;
    font-size: 12px;
    .menu-item{
      cursor: pointer;
      text-align: center;
      height: 32px;
      line-height: 32px;
      &:hover{
        background-color: #409EFF;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/Tabs.vue